<template>
  <div class="timed-message">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--定时消息设置-->
      <div class="common-form">定时消息发送设置</div>
      
      <el-form-item label="发送频率">
        <el-radio-group v-model="form.frequency">
          <el-radio label="once">只发一次</el-radio>
          <el-radio label="daily">每天</el-radio>
          <el-radio label="monthly">每月</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 只发一次设置 -->
      <template v-if="form.frequency === 'once'">
        <el-form-item label="发送日期">
          <el-date-picker
            v-model="form.once_date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择发送日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="发送时间">
          <el-time-picker
            v-model="form.once_time"
            value-format="HH:mm:ss"
            placeholder="选择发送时间">
          </el-time-picker>
        </el-form-item>
      </template>

      <!-- 每天发送时间 -->
      <el-form-item label="发送时间" v-if="form.frequency === 'daily'">
        <el-time-picker
          v-model="form.daily_time"
          value-format="HH:mm:ss"
          placeholder="选择发送时间">
        </el-time-picker>
      </el-form-item>

      <!-- 每月发送设置 -->
      <template v-if="form.frequency === 'monthly'">
        <el-form-item label="每月日期">
          <el-select 
            v-model="form.monthly_days" 
            multiple 
            placeholder="选择日期"
            style="width: 100%; max-width: 460px;">
            <el-option
              v-for="day in 31"
              :key="day"
              :label="`${day}号`"
              :value="day">
            </el-option>
          </el-select>
          <div class="tips">可多选，将在选中的日期发送消息</div>
        </el-form-item>
        <el-form-item label="发送时间">
          <el-time-picker
            v-model="form.monthly_time"
            value-format="HH:mm:ss"
            placeholder="选择发送时间">
          </el-time-picker>
        </el-form-item>
      </template>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="addMessage" :disabled="!formValid">添加消息</el-button>
        <el-button type="success" @click="saveAllMessages" :loading="loading">保存</el-button>
      </div>
    </el-form>

    <!--消息列表表格-->
    <div class="common-form" style="margin-top: 30px;">消息列表</div>
    <el-table :data="messageList" border style="width: 100%; margin-top: 20px;">
      <el-table-column prop="title" label="标题" width="200">
        <template v-slot="scope">
          <el-input
            v-model="scope.row.title"
            placeholder="请输入标题最多20个字符"
            @change="autoSave"
            size="mini">
          </el-input>
        </template>
      </el-table-column>

      <el-table-column prop="content" label="内容" min-width="300">
        <template v-slot="scope">
          <el-input
            type="textarea"
            v-model="scope.row.content"
            placeholder="请输入内容最多20个字符"
            :rows="3"
            @change="autoSave"
            size="mini">
          </el-input>
        </template>
      </el-table-column>

      <el-table-column prop="tips" label="温馨提示" width="200">
        <template v-slot="scope">
          <el-input
            type="textarea"
            v-model="scope.row.tips"
            placeholder="请输入温馨提示最多20个字符"
            :rows="2"
            @change="autoSave"
            size="mini">
          </el-input>
        </template>
      </el-table-column>

      <el-table-column prop="frequency" label="频率" width="120">
        <template v-slot="scope">
          <el-select 
            v-model="scope.row.frequency" 
            @change="handleFrequencyChange(scope.row)"
            size="mini"
            style="width: 100%;">
            <el-option label="只发一次" value="once"></el-option>
            <el-option label="每天" value="daily"></el-option>
            <el-option label="每月" value="monthly"></el-option>
          </el-select>
        </template>
      </el-table-column>

      <el-table-column prop="schedule" label="发送时间" width="250">
        <template v-slot="scope">
          <div class="time-setting">
            <!-- 只发一次的时间设置 -->
            <div v-if="scope.row.frequency === 'once'">
              <el-date-picker
                v-model="scope.row.once_date"
                type="date"
                value-format="yyyy-MM-dd"
                size="mini"
                style="width: 120px; margin-right: 5px;"
                placeholder="日期"
                @change="autoSave">
              </el-date-picker>
              <el-time-picker
                v-model="scope.row.once_time"
                value-format="HH:mm:ss"
                size="mini"
                style="width: 100px;"
                placeholder="时间"
                @change="autoSave">
              </el-time-picker>
            </div>
            
            <!-- 每天的时间设置 -->
            <div v-else-if="scope.row.frequency === 'daily'">
              <el-time-picker
                v-model="scope.row.daily_time"
                value-format="HH:mm:ss"
                size="mini"
                style="width: 120px;"
                placeholder="选择时间"
                @change="autoSave">
              </el-time-picker>
            </div>
            
            <!-- 每月的时间设置 -->
            <div v-else-if="scope.row.frequency === 'monthly'">
              <div style="margin-bottom: 5px;">
                <el-select 
                  v-model="scope.row.monthly_days" 
                  multiple 
                  size="mini"
                  placeholder="选择日期"
                  style="width: 120px; margin-right: 5px;"
                  @change="autoSave">
                  <el-option
                    v-for="day in 31"
                    :key="day"
                    :label="`${day}号`"
                    :value="day">
                  </el-option>
                </el-select>
              </div>
              <el-time-picker
                v-model="scope.row.monthly_time"
                value-format="HH:mm:ss"
                size="mini"
                style="width: 120px;"
                placeholder="选择时间"
                @change="autoSave">
              </el-time-picker>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="status" label="状态" width="100">
        <template v-slot="scope">
          <el-switch
            v-model="scope.row.status"
            @change="autoSave"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
          <div style="margin-top: 5px; font-size: 12px;">
            {{ scope.row.status ? '启用' : '停用' }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="100">
        <template v-slot="scope">
          <el-button 
            size="mini" 
            type="danger" 
            @click="deleteMessage(scope.$index)"
            icon="el-icon-delete">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import SettingApi from '@/api/setting.js';

  export default {
    data() {
      return {
        /*form表单数据*/
        form: {
          frequency: 'once', // once, daily, monthly
          once_date: this.getTomorrowDate(), // 默认明天
          once_time: '09:00:00',
          daily_time: '09:00:00',
          monthly_days: [1], // 改为数组，支持多选
          monthly_time: '09:00:00'
        },
        /*消息列表*/
        messageList: [],
        /*加载状态*/
        loading: false,
        /*自动保存计时器*/
        saveTimer: null
      };
    },
    computed: {
      /*表单验证*/
      formValid() {
        switch (this.form.frequency) {
          case 'once':
            return this.form.once_date && this.form.once_time;
          case 'daily':
            return this.form.daily_time;
          case 'monthly':
            return this.form.monthly_days.length > 0 && this.form.monthly_time;
          default:
            return false;
        }
      }
    },
    created() {
      this.getData();
    },

    methods: {
      /*获取明天的日期*/
      getTomorrowDate() {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow.toISOString().split('T')[0];
      },

      /*获取数据*/
      getData() {
        let self = this;
        SettingApi.getDyMessages({}, true)
          .then(data => {
            // 根据接口返回的数据结构调整
            self.messageList = data.data.messages;
          })
          .catch(error => {
            console.error('获取数据失败:', error);
            self.messageList = [];
          });
      },

      /*添加消息*/
      addMessage() {
        if (!this.formValid) {
          this.$message.warning('请填写完整信息');
          return;
        }

        const newMessage = {
          id: Date.now(), // 临时ID
          title: '',
          content: '',
          tips: '',
          frequency: this.form.frequency,
          once_date: this.form.once_date,
          once_time: this.form.once_time,
          daily_time: this.form.daily_time,
          monthly_days: [...this.form.monthly_days], // 复制数组
          monthly_time: this.form.monthly_time,
          status: true,
          create_time: new Date().toLocaleString()
        };

        this.messageList.unshift(newMessage);
        this.$message.success('消息添加成功');
        
        // 自动保存
        this.autoSave();
      },

      /*删除消息*/
      deleteMessage(index) {
        this.$confirm('确定要删除这条消息吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.messageList.splice(index, 1);
          this.autoSave();
          this.$message.success('删除成功');
        }).catch(() => {});
      },

      /*频率改变时的处理*/
      handleFrequencyChange(row) {
        // 根据新的频率初始化时间字段
        switch (row.frequency) {
          case 'once':
            if (!row.once_date) row.once_date = this.getTomorrowDate();
            if (!row.once_time) row.once_time = '09:00:00';
            // 清空其他频率的时间字段
            row.daily_time = '';
            row.monthly_days = [];
            row.monthly_time = '';
            break;
          case 'daily':
            if (!row.daily_time) row.daily_time = '09:00:00';
            // 清空其他频率的时间字段
            row.once_date = '';
            row.once_time = '';
            row.monthly_days = [];
            row.monthly_time = '';
            break;
          case 'monthly':
            if (!row.monthly_days || row.monthly_days.length === 0) row.monthly_days = [1];
            if (!row.monthly_time) row.monthly_time = '09:00:00';
            // 清空其他频率的时间字段
            row.once_date = '';
            row.once_time = '';
            row.daily_time = '';
            break;
        }
        this.autoSave();
      },

      /*自动保存*/
      autoSave() {
        // 防抖处理，避免频繁保存
        if (this.saveTimer) {
          clearTimeout(this.saveTimer);
        }
        this.saveTimer = setTimeout(() => {
          this.saveMessageList();
        }, 1000);
      },

      /*保存消息列表到服务器*/
      saveMessageList() {
        // 根据后端接口调整数据结构
        const saveData = {
          messages: this.messageList
        };
        
        SettingApi.saveDyMessages(saveData, true)
          .then(data => {
            console.log('消息列表保存成功');
          })
          .catch(error => {
            console.error('保存失败:', error);
          });
      },

      /*保存所有设置*/
      saveAllMessages() {
        this.loading = true;
        // 根据后端接口调整数据结构
        const saveData = {
          messages: this.messageList
        };
        
        SettingApi.saveDyMessages(saveData, true)
          .then(data => {
            this.loading = false;
            this.$message({
              message: '所有设置保存成功',
              type: 'success'
            });
          })
          .catch(error => {
            this.loading = false;
            this.$message.error('保存失败');
          });
      }
    },
    
    beforeDestroy() {
      if (this.saveTimer) {
        clearTimeout(this.saveTimer);
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/views/setting/dingyue/index.vue